import { type IntlShape } from '@formatjs/intl'
import { type IntlShape as ReactIntlShape } from 'react-intl'

export const i18nGetCurrencySymbol = (
  currency: string,
  intl: IntlShape | ReactIntlShape,
): string =>
  intl
    .formatNumber(0, {
      currency,
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
      style: 'currency',
    })
    .replaceAll(/\d/gu, '')
    .trim()
